import { createVNode, render, watch } from "vue";
import { AxiosResponse } from "axios";
import { KeenSliderInstance } from "keen-slider";
import { useNgSession } from "@sazka/ng/ng-session";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import GamesCard from "./components/games-card-game.vue";
import { initCarousel } from "./composables/use-cards-grid-carousel";
import { GamesCardGame } from "./models/game-card-game";
import { PlayersGamesFeeds } from "./models/players-games-feeds";

enum FeedType {
    MostPlayed,
    SmartRecommended,
}

const { isLoggedIn } = useNgSession();

const mostPlayedWidget = document.querySelector<HTMLElement>(".games-players-most-played");
const smartRecommendedWidget = document.querySelector<HTMLElement>(".games-smart-recommended");
let mostPlayedCarusel: KeenSliderInstance = null;
let smartRecommendedCarusel: KeenSliderInstance = null;

const hideWidget = (widget: HTMLElement) => {
    widget?.classList?.add("d-none");
};
const showWidget = (widget: HTMLElement) => {
    widget?.classList?.remove("d-none");
};

const initFeed = async (widget: HTMLElement, games: GamesCardGame[], type: FeedType) => {
    if (!games?.length) {
        hideWidget(widget);
        return;
    }

    const carousel = widget.querySelector<HTMLElement>(".games-cards-section");
    if (!carousel) return;

    carousel.innerHTML = "";

    const fragment = document.createDocumentFragment();

    for (const game of games) {
        const carouselItem = document.createElement("div");
        carouselItem.className = "games-cards-section-carousel__item";

        const props = { game, variant: type === FeedType.MostPlayed ? "double" : "default" };
        const cardNode = createVNode(GamesCard, props);

        render(cardNode, carouselItem);
        fragment.appendChild(carouselItem);
    }

    carousel.appendChild(fragment);

    //init carousel
    widget.querySelector(".games-cards-section__wrapper").classList.add("games-cards-section-carousel");
    widget.querySelector(".games-cards-section-carousel__buttons-wrapper").classList.remove("d-none");

    if (type === FeedType.MostPlayed) {
        mostPlayedCarusel = await initCarousel(widget);
    } else {
        smartRecommendedCarusel = await initCarousel(widget);
    }
};

const initFeeds = async () => {
    let feeds: AxiosResponse<PlayersGamesFeeds, any>;
    try {
        feeds = await httpClient.get<PlayersGamesFeeds>(
            `/api/games/players-feeds?includeMostPlayed=${!!mostPlayedWidget}&includeRecommended=${!!smartRecommendedWidget}`
        );
    } catch (e) {
        console.error("Nepodařilo se načíst data pro nejhranější a doporučované: ", e);
        return;
    }

    if (mostPlayedWidget) {
        showWidget(mostPlayedWidget);
        await initFeed(mostPlayedWidget, feeds.data.mostPlayed, FeedType.MostPlayed);
    }

    if (smartRecommendedWidget) {
        showWidget(smartRecommendedWidget);
        await initFeed(smartRecommendedWidget, feeds.data.recommended, FeedType.SmartRecommended);
    }
};

document.ready(async () => {
    watch(
        isLoggedIn,
        async (isLoggedInValue) => {
            if (isLoggedInValue) {
                await initFeeds();
            } else {
                hideWidget(mostPlayedWidget);
                mostPlayedCarusel?.destroy();
                hideWidget(smartRecommendedWidget);
                smartRecommendedCarusel?.destroy();
            }
        },
        { immediate: true }
    );
});
